export const ACCOUNT_SETTINGS_ROUTE = "/account-settings";
export const LEGACY_CONSOLE_PATH = "/#!/settings";

// Drives the "How would you like to check customer addresses?" radio step of the
// Delivery Zone dialog. "both" fans out to setting both fieldsToShow flags at once.
export const SELF_DELIVERY_FIELD_CHOICES = [
  { value: "maxDeliveryMiles", label: "Only check that addresses are within a set delivery distance" },
  { value: "allowedZipCodes", label: "Only check that address zip codes are in a set list of zip codes" },
  { value: "both", label: "Check addresses against both delivery distance and zip codes" },
];

// Drives the "What Type of Checkout Limit Do You Want to Configure?" radio step of the
// Checkout Limitations dialog. Each value routes to its own branch-specific wizard step.
export const THROTTLE_EFFECT_TYPE_OPTIONS = [
  { value: "order_rate_limit", label: "Order Frequency" },
  { value: "tag_minmax", label: "Order Size (quantity)" },
  { value: "items_pretax_minmax", label: "Order Subtotal ($)" },
  { value: "tag_prereq", label: "Prerequisites for order items at checkout" },
  { value: "tag_rate_limit", label: "Item Tag Quantity/Frequency" },
];

export const DAY_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const DAY_LABELS: Record<string, string> = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

export const ORDER_RATE_LIMIT_SCHEDULE_PLACEHOLDER = "11AM - 2AM";

export const buildEmptyWeeklySchedule = () =>
  DAY_ORDER.reduce(
    (schedule, day) => ({ ...schedule, [day]: { military_times: [], customer_input: "" } }),
    {} as Record<string, { military_times: number[][]; customer_input: string }>
  );

export const NEW_ORDER_RATE_LIMIT = {
  name_for_owner: "",
  start_date: null,
  end_date: null,
  max_orders_per_desired_time: null,
  active_schedule: buildEmptyWeeklySchedule(),
  effect_type: "",
  checkout_blocking_tag: "",
  checkout_blocking_tag_min_qty: null,
  checkout_blocking_tag_max_qty: null,
  items_pretax_min: null,
  items_pretax_max: null,
  prereq_tag: "",
  prereq_tag_min_qty: 1,
  prereq_tag_minutes_in_past: 0,
  unlocked_tag: "",
  unlocked_tag_max_qty: null,
  message_if_violated: "",
  fulfillment_methods: [] as string[],
  location_ids: [] as string[],
  rate_limited_tag: "",
  max_rate_limited_tag_per_desired_time: null,
  max_rate_limited_tag_per_day: null,
  max_rate_limited_tag_between_start_and_end: null,
};

// Mirrors ownerservices.js's integrationDisplayConfigByCategory, filtered to the 4 types
// this remnant manages (Toast/Relay/DoorDash Drive/etc. are handled by the App Store instead).
export const INTEGRATION_CATALOG: Record<string, { title: string; buttonText: string; connectedButtonText?: string }> =
  {
    master_account: { title: "MasterSync", buttonText: "Configure Sync", connectedButtonText: "Configured" },
    omnivore: { title: "Omnivore MMS", buttonText: "Connect Omnivore MMS" },
    omnivore_direct: { title: "Omnivore Direct", buttonText: "Connect Omnivore Direct" },
    omnivore_3: { title: "Omnivore 3", buttonText: "Connect Omnivore" },
  };

export const ACTION_ON_FAILURE_OPTIONS = [
  { value: "accept", label: "Accept checkout, fulfill solely with TOP by DoorDash" },
  { value: "abort", label: "Abort checkout and refund the guests" },
];

export const ACTION_ON_SUCCESS_OPTIONS = [
  {
    value: "open",
    label: "Keep the ticket open in TOP by DoorDash. Staff will update status in TOP by DoorDash to notify guests.",
  },
  { value: "close", label: "Close the ticket in TOP by DoorDash. Guests won't receive feedback about their orders" },
];

export const MOVED_CARDS = [
  {
    key: "billing",
    title: "Billing",
    message: "Our billing settings have moved.",
    linkText: "Go to Payouts and Billing",
    url: "/payouts-and-billing",
  },
  {
    key: "tips",
    title: "Tip Settings",
    message: "Our tip settings have moved.",
    linkText: "Go to Tip Settings",
    url: "/tip-settings",
  },
  {
    key: "service-charges",
    title: "Service Charges",
    message: "Our service charge settings have moved.",
    linkText: "Go to Service Charges",
    url: "/service-charges",
  },
  {
    key: "restaurant-details",
    title: "Address, Contact, and Tax Rate",
    message: "Your address, contact info, and default tax rate have moved.",
    linkText: "Go to Restaurant Details",
    url: "/restaurant-details",
  },
];
